var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69992 13.2197H3.67997C2.74189 13.2197 2.27285 13.2197 1.91456 13.0295C1.59938 12.8621 1.34314 12.5951 1.18256 12.2666C1 11.8932 1 11.4043 1 10.4267V3.79308C1 2.81542 1 2.32658 1.18256 1.95316C1.34314 1.62468 1.59938 1.35763 1.91456 1.19027C2.27285 1 2.7419 1 3.67997 1H13.3949C14.3329 1 14.802 1 15.1603 1.19027C15.4754 1.35763 15.7317 1.62468 15.8922 1.95316C16.0748 2.32658 16.0748 2.81542 16.0748 3.79308V7.10987M1 4.49135H16.0748",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4847 14.4351L15.3324 9.38539M15.3927 14.2963L10.4238 9.52485",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.ac9c837acbfe1b1bc53d4b287e538fb4.svg";
export { ForwardRef as ReactComponent };